define('TescoMobile_Checkout/js/product/view/upgrade',['uiComponent', 'ko', 'jquery', 'Magento_Customer/js/customer-data', 'mage/translate'], function (Component, ko, $, customerData, $t) {
  'use strict';

  return Component.extend({
    defaults: {
      upgradeBtnLabel: $t('Upgrade to this phone'),
      isLoggedIn: false,
      isEligibleForPhoneUpgrade: false
    },
    initialize: function () {
      this._super();
      const customerInfo = customerData.get('customer-info');
      const customer = customerData.get('customer');
      customerInfo.subscribe(this.handleCustomerInfoUpdate, this);
      customer.subscribe(this.handleCustomer, this);
      this.handleCustomerInfoUpdate(customerInfo());
      this.handleCustomer(customer());
    },
    initObservable: function () {
      return this._super().observe(['upgradeBtnLabel', 'isLoggedIn', 'isEligibleForPhoneUpgrade']);
    },
    handleCustomer: function (data) {
      this.isLoggedIn(data === null || data === void 0 ? void 0 : data.firstname);
    },
    handleCustomerInfoUpdate: function (data) {
      var _data$upgrade_info;
      this.isEligibleForPhoneUpgrade(!!(data !== null && data !== void 0 && (_data$upgrade_info = data.upgrade_info) !== null && _data$upgrade_info !== void 0 && _data$upgrade_info.is_eligible_for_phone_upgrade));
      this.setUpgradeBtnLabel();
    },
    isExistingCustomer: function () {
      if (this.isLoggedIn()) {
        $('body').trigger('customer-upgrade');
      } else {
        $('body').trigger('guest-upgrade');
      }
    },
    setUpgradeBtnLabel: function () {
      var _window, _window2, _agent;
      if (typeof ((_window = window) === null || _window === void 0 || (_window = _window.earlyUpgrade) === null || _window === void 0 ? void 0 : _window.btnLabel) !== "undefined" && ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.earlyUpgrade) === null || _window2 === void 0 ? void 0 : _window2.btnLabel) !== '') {
        this.upgradeBtnLabel(window.earlyUpgrade.btnLabel);
      }
      const agent = customerData.get('case-details');
      if (['newOrder', 'addSub'].includes((_agent = agent()) === null || _agent === void 0 ? void 0 : _agent.action)) {
        $('#upgrade-button').detach();
      }
      agent.subscribe(function (data) {
        var _agent2;
        if (['newOrder', 'addSub'].includes((_agent2 = agent()) === null || _agent2 === void 0 ? void 0 : _agent2.action)) {
          $('#upgrade-button').detach();
        }
      }, this);
    }
  });
});

